import i18next from 'i18next';

export const generateTranslation = (part: string) => {
    const translation: string = 'POLICY_AUTH_TYPE_' + part.toUpperCase();
    return i18next.t(translation);
};
